import Api from '../../../common/services/api';

export const NETWORK_UPDATE_FUNCTION_USERS = 'network/UPDATE_FUNCTION_USERS';

export default (functionId, users) => async (dispatch, getState) => {
  const { network: { selected }, network: { teams } } = getState();

  await Api.put(`/v2/networks/${selected}/functions/${functionId}/users`, users);
  const { data: item } = await Api.get(`/v2/networks/${selected}/functions/${functionId}`);

  return dispatch({
    type: NETWORK_UPDATE_FUNCTION_USERS,
    functionId,
    item,
  });
};
